module.exports = new __parcel__URL__("RestrictedContentIcon-Light.e0fef1fb.svg").toString();